(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const filterGroups = document.querySelectorAll(
      ".sbw-facet .sbw-facet-title"
    );

    filterGroups.forEach((group) => {
      const groupContainer = group.closest(".sbw-facet");
      const groupContent = groupContainer.querySelector(".sbw-facet-values");

      // Collapse all filter groups initially
      groupContent.style.display = "none";

      // Toggle on click
      group.addEventListener("click", () => {
        const isVisible = groupContent.style.display === "block";
        groupContent.style.display = isVisible ? "none" : "block";
      });
    });
  });
})();
